var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "additions" }, [
    _c(
      "table",
      [
        _vm.isListStyling
          ? _c("tr", [_c("td", [_vm._v(_vm._s(_vm.list))])])
          : [
              _vm.experience
                ? _c("tr", [
                    _c("td", [_vm._v("Erfahrung:")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.experience))])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.selfAssessment
                ? _c("tr", [
                    _c("td", [_vm._v("Kenntnisse:")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.selfAssessment))])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.supplements
                ? _c("tr", [
                    _c("td", { attrs: { colspan: "2" } }, [
                      _vm._v(_vm._s(_vm.supplements))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.specificities
                ? _vm._l(_vm.specificities, function(item) {
                    return _c("tr", [
                      item.label
                        ? _c("td", [_vm._v(_vm._s(item.label) + ":")])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.value))])
                    ])
                  })
                : _vm._e()
            ],
        _vm._v(" "),
        _vm.withEditButton || _vm.deletable
          ? _c("tr", { staticClass: "actions" }, [
              _c("td", { attrs: { colspan: "2" } }, [
                _vm.withEditButton
                  ? _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.$emit("edit")
                          }
                        }
                      },
                      [
                        _c("Icon", { attrs: { icon: "pencil" } }),
                        _vm._v("\n\t\t\t\t\tBearbeiten\n\t\t\t\t")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.deletable
                  ? _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.$emit("delete")
                          }
                        }
                      },
                      [
                        _c("Icon", { attrs: { icon: "bin" } }),
                        _vm._v("\n\t\t\t\t\tLöschen\n\t\t\t\t")
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }